/**
 * Hides edit-only inspector sections while scene authoring is locked by physics.
 *
 * @param {object} props
 * @param {boolean} props.locked
 * @param {React.ReactNode} props.children
 */
export default function InspectorPhysicsLockedCollapsibleWrap({ locked, children }) {
  if (locked) return null;
  return children;
}
